export default class OptionsFactory {
    // #region Vars
    _appHost;
    // #endregion
    // #region Constructor
    constructor(appHost) {
        this._appHost = appHost;
    }
    // #endregion
    // #region Get
    get(name, ...args) {
        // #region Args
        if (args.length > 0) {
            let tItem = args.find((e) => {
                if (!e) {
                    return false;
                }
                if (e[name] === undefined || e[name] === null) {
                    return false;
                }
                return true;
            });
            if (tItem !== undefined && tItem !== null) {
                return tItem[name];
            }
        }
        // #endregion
        // #region Session
        let tSessionOptions = this._appHost?.session?.options;
        {
            if (tSessionOptions && tSessionOptions[name] !== undefined && tSessionOptions[name] !== null) {
                return tSessionOptions[name];
            }
        }
        // #endregion
        // #region Options
        let tOptions = this._appHost.config.options;
        {
            if (tOptions && tOptions[name] !== undefined && tOptions[name] !== null) {
                return tOptions[name];
            }
        }
        // #endregion
        return null;
    }
}
